// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.codicon-debug-alt:before {
    font-family: "FontAwesome" !important;
    content: "\\e905" !important;
}
`, "",{"version":3,"sources":["webpack://./../../actions-runner/_work/arduino-ide/arduino-ide/arduino-ide-extension/src/browser/style/custom-codicon.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,2BAA2B;AAC/B","sourcesContent":[".codicon-debug-alt:before {\r\n    font-family: \"FontAwesome\" !important;\r\n    content: \"\\e905\" !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
